export default "__VITE_ASSET__BUG0F3PE__"